var env = require("../utils/env");
var apiDomain = env.domain.api;
// var Auth = require("./auth");
var request = require('superagent');

var exports = module.exports = {};

exports.retrieveReviewTaskList = function(options, callback) {
  callback = callback || function(){};
  request.get(apiDomain + "/v1/review_task")
  .query(options.query)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.retrieveSingleReviewTask = function(options, callback) {
  callback = callback || function(){};
  var api = apiDomain + "/v1/review_task" + (options.taskId ? ('/' + options.taskId) : '');
  request.get(api)
  .query(options.query)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err.response.body);
  })
}

exports.submitQuestionReview = function(urlOption, valueOption, callback) {
  callback = callback || function(){};
  request.post(apiDomain + "/v1/review_task/" + urlOption.taskId + "/question/" + urlOption.questionId)
  .send(valueOption)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.submitAdminQuestionReview = function(urlOption, valueOption, callback) {
  callback = callback || function(){};
  request
  .post(apiDomain + "/v1/kquiz/" + urlOption.collectionId + "/question/" + urlOption.questionId + "/review_task")
  .send(valueOption)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.submitMessage = function(options, callback) {
  callback = callback || function(){};
  options.type = options.type || "TASK_MESSAGE";
  request.post(apiDomain + "/v1/message")
  .send(options)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.updateReviewTask = function(options, callback) {
  callback = callback || function(){};
  request.put(apiDomain + "/v1/review_task/" + options.taskId)
  .send(options.body)
  .withCredentials()
  .then(function(response) {
    return callback(null, response.body);
  }, function(err) {
    return callback(err);
  })
}

exports.getAggregateCountField = function(options, callback) {
  callback = callback || function(){};
  if (!options.groupFields) return callback("INVALID GROUP FIELDS");
  request
  .get(apiDomain + "/v1/review_task/aggregate")
  .query({
    aggregate_cmds: "count",
    aggregate_fields: "*",
    aggregate_aliases: "count",
    group_fields: options.groupFields,
    conditions: options.conditions
  })
  .withCredentials()
  .then(function(res) {
    return callback(null, res.body)
  }, function(err) {
    return callback(err);
  });
}



/** WEBPACK FOOTER **
 ** ./src/resources/review_task.js
 **/